export * from './delete-ort-kategorie.component';
export * from './delete-ort-kategorie.component.module';